// For /user-panel/orders/draft-order
export default [
    {
        key: 'id',
        label: 'Boxiti ID',
        sortable: true
    },
    {
        key: 'address.fullName',
        label: 'Buyer',
        sortable: true
    },
    {
        key: 'createdAt',
        label: 'Date',
        sortable: true
    },
    {
        key: 'currencyCode',
        label: 'Currency',
        // sortable: true
    },
    {
        key: 'address.country.nameEn',
        label: 'Country of delivery',
        sortable: true
    },
    {
        key: 'total',
        label: 'Total',
        sortable: true
    },
    {
        key: 'currencyCode',
        label: 'Currency',
        // sortable: true,
        variant: 'column-md'
    },
    {
        key: 'actions',
        label: ''
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/ordersDraft.js